import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'gatsby'
import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import { faGlobe } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
config.autoAddCss = false

const Footer = ({ pathname, linksTo, noEnglish }) => (
  <footer>
    <Container fluid>
      <Row>
        <Col>
          <div className="container col-11 footer">
            <div className="row mb-5 pt-5">
              <div className="col-12 col-md-3 mt-4">
                <strong>Contact us</strong>
                <br />
                <strong>E</strong> hallo@ganztags.net
              </div>
              <div className="col-12 col-md-5 mt-4">
                <strong>About ganztags.</strong>
                <br />
                <Link to="/en/team/">About us</Link>&nbsp;| <Link to="/en/services/">Services</Link>&nbsp;|{' '}
                <Link to="/en/clients/">Clients</Link>&nbsp;| <Link to="/en/careers/">Careers</Link>&nbsp;|{' '}
                <Link to="/en/contact/">Contact</Link>{' '}
              </div>
              {noEnglish ? null : (
                <div className="col-12 col-md-4 text-md-right mt-4">
                  <a href={linksTo ? `/${linksTo}` : pathname.replace('/en', '')}>
                    <FontAwesomeIcon icon={faGlobe} /> Deutsche Version
                  </a>
                </div>
              )}
            </div>
            <Row className="pt-3 pb-5">
              <Col xs={12} sm={3}>
                <h3>
                  <strong>ganztags.</strong>
                </h3>
              </Col>
              <Col>
                <a href="/impressum/" id="imp">
                  Legal Notice & Privacy Policy (in German only)
                </a>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  </footer>
)

export default Footer
